import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators';
import { BusinessErrorService } from '../../services/error/business-error.service';
import { ErrorService } from '../../services/error/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private businessErrorService: BusinessErrorService, private errorService: ErrorService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let unhandler = request.url.includes('/codigo/envio')
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if(error.status ===  460 && !unhandler) {
          this.businessErrorService.handleError(error);
        } else {
          this.errorService.handleError(error)
        }
        return throwError(error);
      })
    );
  }
}
